import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "antd";
import { Integration } from "/app/src/models";

import ManyTransactions from "./manyTransactions";

/**
 * A functional component that renders a translation header and the ManyTransactions component.
 *
 * @param {Object} param0 - The component props.
 * @param {Integration} param0.integration - Integration object used by the component.
 * @returns {JSX.Element} The rendered component.
 */
export default function Test({ integration }: { integration: Integration }) {
  const { t } = useTranslation();

  return (
    <Row justify="start" gutter={16}>
      <Col span={24}>
        <h2>{t("translation:send_transactions_manually")}</h2>
        <ManyTransactions integration={integration} />
      </Col>
    </Row>
  );
}
